// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","App-logo":"App_App-logo__yMrik","App-logo-spin":"App_App-logo-spin__1up6W","App-header":"App_App-header__PyRwd","App-link":"App_App-link__XPeK4"};